<template>
  <div class="mobile-table-content">
    <div class="table-title">
      <div class="title-left"><i class="el-icon-s-management" />计划信息</div>
      <div class="title-right"></div>
    </div>
    <!-- 付款信息 -->
    <div class="list-content">
      <CommonDetail :listConfig="listConfig" :listData="listData">
      </CommonDetail>
    </div>
    
    <!-- 内扣明细 -->
    <div class="table-title">
      <div class="title-left">内扣明细</div>
      <div class="title-right"></div>
    </div>
    <div class="list-content">
      <el-table
        :data="listData.innerList"
        border
        style="width: 100%"
      >
        <el-table-column
          type="index"
          align="center"
          label="序号"
          width="50"
        >
        </el-table-column>
        <el-table-column
          align="center"
          property="moneyType"
          label="款项类型"
        >
          <template slot-scope="scope">
            <div
              class="money-type"
              v-if="scope.row.dictMainOutlayType == 2"
            >
              卖方保证金
            </div>
            <div class="money-type" v-else>
              {{ scope.row.outlayTypeStr }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="outlayAmount"
          label="应收金额（元）"
          width="120"
        >
          <template slot-scope="scope">
            {{ getMoney(Number(scope.row.outlayAmount)) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="innerPayment"
          label="当前可内扣金额（元）"
          width="180"
        >
          <template slot-scope="scope">
            {{ getMoney(Number(scope.row.innerPayment)) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="innerMoney"
          label="本次内扣金额（元）"
          width="160"
        >
          <template slot-scope="scope">
            {{ getMoney(Number(scope.row.innerMoney)) }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 支付计划表 -->
    <div class="table-title" style="">
      <div class="title-left">支付计划表</div>
      <div class="title-right"></div>
    </div>
    <div class="list-content">
      <el-table
        :data="listData.planList"
        border
        show-summary
        :summary-method="setSummary"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label="期数"
          property="issue"
          width="50"
        >
        </el-table-column>
        <el-table-column
          align="center"
          property="rentDay"
          label="还款日"
          type="string"
          width="90"
        >
          <template slot-scope="scope">
            {{dateConvert(scope.row.rentDay)}}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="expectedRent"
          label="每期首付款及使用费合集额（元）"
          width="140"
          show-summary
        >
          <template slot-scope="scope">
            {{ getMoney(Number(scope.row.expectedRent)) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="principal"
          label="每期保理首付款"
          width="120"
        >
          <template slot-scope="scope">
            {{ getMoney(Number(scope.row.principal)) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="interest"
          label="每期使用费"
          width="120"
        >
          <template slot-scope="scope">
            {{ getMoney(Number(scope.row.interest)) }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          property="residualPrincipal"
          label="剩余首付款"
          width="120"
        >
          <template slot-scope="scope">
            {{ getMoney(Number(scope.row.residualPrincipal)) }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          property="cashFlow"
          label="现金流量"
          width="120"
        >
          <template slot-scope="scope">
            {{ getMoney(Number(scope.row.cashFlow)) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="isWriteoff"
          label="备注"
        >
          <template slot-scope="scope">
            {{
              scope.row.isWriteoff == 2
                ? "提前结清"
                : scope.row.isWriteoff == 1
                ? "已结清"
                : scope.row.isWriteoff == 0
                ? listData.prepayment.isWriteoff == 1
                  ? "提前还款"
                  : "待结清"
                : ""
            }}
          </template>        
        </el-table-column>        
      </el-table>
    </div>
  </div>
</template>
<script>
import CommonDetail from "@/components/workflowComponents/mobile/commonDetail";
import { mapGetters } from "vuex";
import util from "@/mixins/util";
export default {
  name: "mobileContractManage",
  mixins: [util],
  data() {
    return {
      tableData: [],
      listConfig: [
        {
          label: "保理合同",
          prop: "contractName",
        },
        {
          label: "放款批次",
          prop: "investBatchStr",
        },
        {
          label: "报价方案",
          prop: "planName",
        },
        {
          label: "放款日期",
          prop: "planPayDate",
        },
        {
          label: "本笔放款金额",
          prop: "investMoney",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },          
        },
        {
          label: "内扣合计金额",
          prop: "innerCost",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },          
        },
        {
          label: "实际应付金额",
          prop: "investShouldMoney",
          formatter: (label, value) => {
            return this.getMoney(value) + "元";
          },          
        },
        {
          label: "支付方式",
          prop: "payTypeStr"        
        },
        {
          label: "补充说明",
          prop: "remarks",
          type:'textarea'
        },

        
      ],
    };
  },
  components: {
    CommonDetail,
  },
  props: {
    listData: {
      type: Object,
      default: () => {
        return {};
      },
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    setSummary(param) {
      const self = this
      const { columns } = param;
      const sums = [];
      if(columns.length == 0 || !this.listData.planList) return false
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if(index == 1 || index == 7) {
          sums[index] = '-'
          return
        }
        const values = self.listData.planList.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          });
          sums[index] = `${this.getMoney(sums[index].toFixed(2))}元`;
        } else {
          sums[index] = '-';
        }
      });
      return sums
    }
    
  },
};
</script>
<style lang="scss" scoped>
.mobile-table-content {
  .table-title {
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1rem;
    margin-top: 0.2rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    .title-left {
      font-size: .38rem;
      color: #666;
      font-weight: 600;
    }
    .title-right {
      font-size: .38rem;
      color: #ccc;
    }
  }
  .list-content {
    .info-one {
      background-color: #fff;
      border-top: 0.5px solid #f2f2f2;
      border-bottom: 0.5px solid #f2f2f2;
      padding-left: 0.3rem;
      padding-right: 0.3rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 1.2rem;
      padding-top: 0.15rem;
      padding-bottom: 0.15rem;
      .info-left {
        width: 30%;
        color: #999;
        font-size: .38rem;
      }
      .info-right {
        width: 65%;
        font-size: .38rem;
        text-align: right;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
      }
    }
    /deep/.el-table{
      .cell {
        font-size: .38rem !important;
      }
      th {
        background-color: #fff;
      }
    }
  }
  .item-one {
    background-color: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    width: 100%;
    padding: 0.35rem 0.4rem;
    border-radius: 0.2rem;
    margin-bottom: 0.2rem;
    .item-index {
      font-size: .38rem;
      line-height: 0.7rem;
      color: #999;
      font-weight: 600;
    }
    .item-line {
      font-size: .38rem;
      line-height: 0.55rem;
      color: #999;
      span {
        margin-left: 0.3rem;
      }
    }
    .remark-content {
      font-size: .38rem;
      color: #333;
      line-height: 0.7rem;
    }
  }
}
.info_right_edit {
  color: #409eff !important;
  cursor: pointer !important;
}
</style>